import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'src/utils/axios'
import { backend } from 'src/config'

export const fetchOrderDetails = createAsyncThunk(
  'FETCH_ORDER_DETAILS',
  async ({ orderId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${backend}/api/order/${orderId}`)

      return response.data
    } catch (error) {
      console.error('Error in FETCH_ORDER_DETAILS', error)
      return rejectWithValue([], error)
    }
  }
)

export const fetchOrderUnitDetails = createAsyncThunk(
  'FETCH_ORDER_UNIT_DETAILS',
  async (orderUnitId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${backend}/api/order/orderUnit?orderUnitId=${orderUnitId}`
      )
      return response.data
    } catch (error) {
      console.error('Error in FETCH_ORDER_UNIT_DETAILS', error)
      return rejectWithValue({}, error)
    }
  }
)

export const fetchUpdateLot = createAsyncThunk(
  'FETCH_UPDATE_LOT',
  async ({ orderId, data }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${backend}/api/order/${orderId}`, data)
      return response.data
    } catch (error) {
      console.error('Error in FETCH_UPDATE_LOT', error)
      return rejectWithValue([], error)
    }
  }
)

export const fetchSetOrderUnitPaid = createAsyncThunk(
  'FETCH_SET_ORDER_UNIT_PAID',
  async ({ orderId, orderUnits }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`${backend}/api/order/${orderId}`, {
        id: orderId,
        orderUnits,
      })
      return response.data
    } catch (error) {
      console.error('Error in FETCH_SET_ORDER_UNIT_PAID', error)
      return rejectWithValue({}, error)
    }
  }
)

export const cancelOrderLot = createAsyncThunk(
  'CANCEL_ORDER_LOT',
  async ({ orderUnitIds, enqueueSnackbar, reasonForCancellation }) => {
    const succeeded = []
    const failed = []

    // BACKEND DOES NOT SUPPORT BATCHING FOR THIS REQUEST (PROMISE.ALL DOES NOT WORK)
    for (const orderUnitId of orderUnitIds ?? []) {
      try {
        const response = await axios.put(
          `${backend}/api/order/orderUnit/${orderUnitId}/transfer-cancellation`,
          null,
          { params: { reasonForCancellation } }
        )
        succeeded.push(response.data)
        enqueueSnackbar?.(`Лот ${orderUnitId}: успешно отменён`, {
          variant: 'success',
        })
      } catch (error) {
        const errorMessage =
          error?.messageRu ||
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          'Не удалось отменить лот'
        const finalMessage = `Лот ${orderUnitId}: Ошибка! ${errorMessage}`
        failed.push({ orderUnitId, message: finalMessage })
        enqueueSnackbar?.(finalMessage, { variant: 'error' })
      }
    }

    return { succeeded, failed }
  }
)
